<template>
  <div>
    <div>
      <section-header :ressource="sectionDoc.ressource ? sectionDoc.ressource : undefined"
                      :ref="domRef"
                      :isExtended='extended'
                      :disableExtend="disableExtend"
                      :dialog="dialog"
                      :picto="sectionDoc.picto"
                      :canAdd="canAdd"
                      :maximise="maximise"
                      :chat="sectionDoc.chat"
                      :chat-label="sectionDoc.chatLabel"
                      :unread-chat-count="sectionDoc.unreadChatCount"
                      @closeDialog="closeSection"
                      @fullscreen="setFullscreen"
                      @extended="setExtended"
                      @openChat="openChat">
      </section-header>
    </div>

    <div v-if="extended">
      <div class="col-12 py-0 px-2">
        <div class="crud-container crud-bg py-2">
          <PDFJSViewer v-if="!openFullscreen"
                       :fullscreen="fullscreen"
                       :fileUrl="fileUrl"
                       :bookmarks="fullscreen">
          </PDFJSViewer>
        </div>

        <v-row class="justify-end align-center pb-0 pt-4" v-if="!readOnly">
          <div v-if="$slots['footer-status']" class="flex-grow-1 px-2" style="flex-basis: 260px" role="status" aria-live="polite">
            <slot name="footer-status"></slot>
          </div>
          <div v-for="(button, index) in sectionDoc.buttons"
               :key='index'>
            <loader-button v-if="button.show"
                           class="ms-2"
                           :label="button.label"
                           :disabled="(button.disabled || !isDocumentReady) && !isCloseButton(button)"
                           :loading="button.loading"
                           :outlined="button.outlined"
                           @callback="button.callback">
            </loader-button>
          </div>
        </v-row>
      </div>


      <section-container :dialogOpen="dialogOpen"
                         :section="inSection"
                         :fullscreen="openFullscreen"
                         :readOnly="readOnly"
                         @closeDialog="closeDialog">
      </section-container>
    </div>

  </div>
</template>

<script lang="ts">
  import SectionChat from '@/framework/chat/components/SectionChat.vue';
  import Section from '@/framework/base/classes/Section';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionContainer from '@/framework/base/components/SectionContainer.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import PDFJSViewer from '@/framework/document/components/PDFJSViewer.vue';
  import { DocumentModes } from '@/generated/classes/Document';
  import { Extended } from '@/framework/base/classes/Schema';
  import { storeSession, storeDocument } from '@/generated/stores';
  import { ListFilter } from '../../../generated/classes/ListData';
  import HubServices from '@/generated/hub/HubServices';
  import { defineComponent, PropType } from "vue";
  import Document from '@/extend/classes/Document';

  export default defineComponent({
    components: {
      LoaderButton,
      SectionContainer,
      SectionHeader,
      PDFJSViewer
    },
    props: {
      sectionDoc: {
        type: Object as PropType<Section>,
        required: true
      },
      domRef: {
        type: String
      },
      extended: {
        type: Boolean
      },
      dialog: {
        type: Boolean
      },
      showChat: {
        type: Boolean
      },
      canAdd: {
        type: Boolean
      },
      maximise: {
        type: Boolean
      },
      mode: {
        type: Number,
        required: true
      },
      showModif: {
        type: Boolean
      },
      fullscreen: {
        type: Boolean
      },
      sectionRef: {
        type: String
      },
      buttonCallBack: {
        type: Object as PropType<ButtonCallback>
      },
      subSection: {
        type: Object as PropType<Section>
      },
      readOnly: {
        type: Boolean
      },
      disableExtend: {
        type: Boolean
      }
    },
    created () {
      storeDocument.registerDocument(new ListFilter());
    },
    data () {
      const file: File | null = null;

      return {
        mShowChat: false,
        mDialogOpen: false,
        file,
        documentId: 0,
        url: '',
        chatOpen: false,
        openFullscreen: false,
        docRevision: -1,
        filePath: '',
        extension: '',
        lastMode: DocumentModes.NORMAL,
        lastShowModif: false,
        reload: false,
        documentReadyByDocId: {} as Record<number, boolean>
      };
    },
    computed: {
      dialogOpen: {
        get (): boolean {
          if (this.filePath != '' && (this.showChat != this.mShowChat || this.sectionDoc.newChatItem)) {
            this.openChatDialog();
          }
          return this.mDialogOpen;
        },
        set (value: boolean) {
          this.mDialogOpen = value;
        }
      },
      inSection (): Section {
        if (this.chatOpen) {
          return this.sectionChat;
        } else if (this.subSection && this.subSection.component) {
          this.openSectionDialog();
          return this.subSection;
        } else if (this.openFullscreen) {
          debugger;
          return this.sectionPdfViewer();
        } else {
          return new Section();
        }
      },
      sectionChat (): Section {
        const section = new Section();
        section.component = SectionChat;
        section.picto = '';
        section.type = this.sectionDoc.type;
        section.data = this.sectionDoc.data;
        section.propType = 'objType';
        section.propData = this.sectionDoc.objType;
        return section;
      },
      fileUrl (): string {
        let url = import.meta.env.VITE_VUE_APP_SERVER_URL + '/uploads/chargement.pdf';
        if (this.sectionDoc.objId) {
          const document = storeDocument.getDocument(this.sectionDoc.objId);
          console.log('FileUrl : ' + document.filePath + ', ext : ' + document.fileExtension + ', revision : ' + document.revision + ', reload :' + document.reload);
          if (this.documentId != document.id) {
            this.documentChanged();
          }
          const update = this.docRevision != document.revision || this.documentId != document.id ||
            this.lastMode != this.mode || this.lastShowModif != this.showModif || this.extension != document.fileExtension;
          if (document.id > 0 && update && HubServices.hubReady() && storeSession.hubCx) {
            this.updateDocument(document);
            if (document.filePath == '' && document.fileExtension == 'pdf') {
              document.mode = this.mode;
              document.showModif = this.showModif;
              document.reload = this.reload;
              console.log('EXPOSE : ' + document.filePath + ', revision : ' + document.revision + ', reload :' + document.reload);
              storeSession.hubCx.invoke('DocumentExpose', storeSession.httpToken, document);
            }
          }
          if (document.id > 0 && document.filePath != '') {
            this.updateReload(true);
          }
          if (document.filePath && document.filePath != '') {
            console.log('PDF URL : ' + document.filePath);
            url = import.meta.env.VITE_VUE_APP_SERVER_URL + '/' + document.filePath;
            this.updateUrl(url);
            this.documentReadyByDocId[document.id] = true;
          } else if (this.filePath != '') {
            url = this.filePath;
          }
        }
        return url;
      },
      isDocumentReady (): boolean {
        if (this.sectionDoc.objId) {
          const document = storeDocument.getDocument(this.sectionDoc.objId);
          return this.documentReadyByDocId[document.id] || false;
        }
        return false;
      }
    },

    methods: {
      isCloseButton (button: Button): boolean {
        return button.label && button.label.toLowerCase().includes('fermer');
      },
      openSectionDialog () {
        this.dialogOpen = true;
        if (this.subSection && this.subSection.fullscreen) {
          this.openFullscreen = true;
        }
      },
      openChatDialog () {
        this.mShowChat = this.showChat;
        this.chatOpen = this.showChat || this.sectionDoc.newChatItem
        this.mDialogOpen = this.showChat || this.sectionDoc.newChatItem;
      },
      sectionPdfViewer (): Section {
        //this.section.component = this.$options.components?.SectionPdfViewer;
        return this.sectionDoc;
      },
      updateUrl (value: string) {
        this.filePath = value;
      },
      updateReload (value: boolean) {
        this.reload = value;
      },
      documentChanged () {
        this.docRevision = -1;
        this.reload = false;
        this.extension = '';
        if (this.documentId > 0) {
          this.documentReadyByDocId[this.documentId] = false;
        }
      },
      updateDocument (document: Document) {
        this.documentId = document.id;
        this.docRevision = document.revision;
        this.lastMode = this.mode;
        this.lastShowModif = this.showModif;
        this.extension = document.fileExtension;
      },
      openEditor () {
        this.chatOpen = false;
        this.dialogOpen = true;
      },
      openChat (): void {
        this.chatOpen = true;
        this.dialogOpen = true;
      },
      closeSection (): void {
        this.closeDialog();
        this.$emit('closeDialog');
      },
      closeDialog () {
        this.openFullscreen = false;
        this.dialogOpen = false;
        this.chatOpen = false;
        this.$emit('closeSubDialog');
      },
      setFullscreen (): void {
        this.dialogOpen = true;
        this.openFullscreen = true;
      },
      setExtended (context: Extended): void {
        this.$emit('extended', context);
      }
    }
  })

</script>
